import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashCompact from 'lodash/fp/compact';

import SrPartnerListingCard, {
  SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_BLACK,
  SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_GREY_SUNSCREEN,
} from 'client/components/SrPartnerListingCard';
import SrPartnerList from 'client/components/SrPartnerList';
import branch from 'client/core/branch';

import {
  LISTING_IMAGE_PLACEHOLDER_URL,
  LISTING_SERVICE_TYPE_TENANT_SCREENING,
  LISTING_STATUS_ARCHIVED,
} from 'common/listingConstants';

import {
  DATA_TABLE_SOURCE_PARTNER_LISTINGS,
  DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_TENANT_SCREENING,
} from 'common/dataTableConstants';

import { dataTable, actionDataTableLoadNextPage } from 'client/helpers/dataTables';
import withInfiniteScroll from 'client/helpers/withInfiniteScroll';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

export function getDataTableSettingsFromProps(props) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_PARTNER_LISTINGS,
    viewId: `${DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_TENANT_SCREENING}_ARCHIVED_${props.partner.id}`,
    filter: {
      'listings.status': LISTING_STATUS_ARCHIVED,
      'listings.partnerId': props.partner.id,
    },
    customParams: {
      partnerListings: {
        serviceType: LISTING_SERVICE_TYPE_TENANT_SCREENING,
      },
    },
    count: 40,
  };

  if (props.sinceDate) {
    dataTableSettings.viewId = `${dataTableSettings.viewId}_sinceDate:${props.sinceDate}`;
  }

  return dataTableSettings;
}

@dataTable(getDataTableSettingsFromProps)
@branch({
  appUrl: ['env', 'APP_URL'],
})
@withInfiniteScroll({
  offset: 80,
})
class SrDataTablePartnerTentantScreeningArchivedListings extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
    items: PropTypes.array.isRequired,
    apartment: PropTypes.object,
    apartmentBuildingId: PropTypes.array, // eslint-disable-line react/no-unused-prop-types
    dispatch: PropTypes.func.isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
    onInfiniteScrollCallbackReady: PropTypes.func.isRequired,
    partnerListingsViewId: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  };

  constructor(props) {
    super(props);

    const { onInfiniteScrollCallbackReady } = props;
    onInfiniteScrollCallbackReady(this._infiniteScrollCallback);
  }

  _infiniteScrollCallback = () => {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadNextPage, getDataTableSettingsFromProps(this.props));
    }
  };

  _getTitle = (listing) => {
    const { apartment } = this.props;
    const isUnit = !!apartment;
    let title = listing.addressStreetDisplay;

    if (isUnit) {
      const apartmentUnit = listing.apartmentUnit || '';
      title = apartmentUnit.toLowerCase().includes('unit') ? (
        apartmentUnit
      ) : (
        <span>
          <span>{`Unit ${apartmentUnit || '--'} `}</span>
          {listing.floorPlanName && (
            <span className="floorPlanName">{`(${listing.floorPlanName})`}</span>
          )}
        </span>
      );
    }
    return title;
  };

  _getTags = (listing) => {
    return lodashCompact([
      listing.lastArchiveDate && {
        theme: SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_GREY_SUNSCREEN,
        label: momentWithAustinTimezone(listing.lastArchiveDate).format('MMMM DD, YYYY'),
      },
    ]);
  };

  _getBottomChips = (listing) => {
    const label = [`${listing.addressCity},`, listing.addressStateCode].join(' ');

    return [
      {
        label,
        theme: SR_PARTNER_LISTING_CARD_TAG_THEME_WHITE_BLACK,
      },
    ];
  };

  render() {
    const { items: listings, onInfiniteScrollWrapperRef, dataTableApiState, partner } = this.props;

    return (
      <div ref={onInfiniteScrollWrapperRef}>
        <SrPartnerList singleRow>
          {listings.map((listing) => {
            const title = this._getTitle(listing);
            const tags = this._getTags(listing);
            const bottomChips = this._getBottomChips(listing);

            return (
              <SrPartnerListingCard
                hideStatsView
                showViewWithTitle
                to={`/partner/${partner.slug}/listing/${listing.id}`}
                key={listing.id}
                photos={[LISTING_IMAGE_PLACEHOLDER_URL]}
                title={title}
                tags={tags}
                bottomChips={bottomChips}
              />
            );
          })}
        </SrPartnerList>

        {dataTableApiState.inProgress && <div className="loading-ellipses" />}
      </div>
    );
  }
}

SrDataTablePartnerTentantScreeningArchivedListings.displayName =
  'SrDataTablePartnerTentantScreeningArchivedListings';

export default SrDataTablePartnerTentantScreeningArchivedListings;
